import React from "react";

export const PhoneIcon = (props) => {
    const width = props.width ? props.width : "16";
    const height = props.height ? props.height : "16";
    const color = props.color ? props.color : "#091b29";
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
        >
            <defs>
                <clipPath id="clip-path">
                    <rect id="Rectangle_48450" data-name="Rectangle 48450" width="16" height="16" transform="translate(257 136)" fill="#091b29" />
                </clipPath>
            </defs>
            <g id="Group_7015" data-name="Group 7015" transform="translate(-257 -136)">
                <g id="Mask_Group_6286" data-name="Mask Group 6286" clip-path="url(#clip-path)">
                    <path id="icons8-phone_1_" data-name="icons8-phone (1)" d="M8.3,2.46l.563,1.328A1.518,1.518,0,0,1,8.53,5.471l-1.052,1a.5.5,0,0,0-.154.437A5.349,5.349,0,0,0,8,8.731a5.743,5.743,0,0,0,1.271,1.527.5.5,0,0,0,.48.085l1.228-.41a1.333,1.333,0,0,1,1.527.537l.808,1.186a1.521,1.521,0,0,1-.169,1.91l-.536.538a1.979,1.979,0,0,1-2,.51q-2.5-.778-4.589-4.622T4.539,3.462A2.136,2.136,0,0,1,5.948,1.887l.705-.225A1.352,1.352,0,0,1,8.3,2.46Z" transform="translate(256.014 135.848)"
                        fill={color}
                    />
                </g>
            </g>
        </svg>
    );
};